import { Link } from "react-router-dom";
import { MdEmail } from "react-icons/md";
import { IoLogoYoutube } from "react-icons/io5";
import { FaInstagram } from "react-icons/fa6";
import { FaFacebookF } from "react-icons/fa";
import { TiSocialLinkedin } from "react-icons/ti";

const Header = () => {
  return (
    <div className="header d-none d-md-block">
      <div className="container">
        <div className="d-md-flex align-items-center justify-content-between py-2">
          <div>
            <ul className="list-unstyled mb-0">
              <li className="d-flex align-items-center gap-2">
                <MdEmail />
                <a
                  href="mailto:demo@example.com"
                  className="text-white text-decoration-none"
                >
                  contact@elitebodyhome.com
                </a>
              </li>
            </ul>
          </div>
          <div>
            <div className="d-flex gap-3">
              <Link
                to="https://youtube.com/@elitebodyhome"
                className="d-flex align-items-center justify-content-center bg-white bg-opacity-25 rounded-circle text-white"
                style={{ width: "40px", height: "40px" }}
              >
                <IoLogoYoutube />
              </Link>
              <Link
                to="https://www.instagram.com/elitebodyhomeuae?igsh=dTFnbmFobW5lODNk"
                className="d-flex align-items-center justify-content-center bg-white bg-opacity-25 rounded-circle text-white"
                style={{ width: "40px", height: "40px" }}
              >
                <FaInstagram />
              </Link>
              <Link
                to="https://www.facebook.com/elitebodyhomeuae"
                className="d-flex align-items-center justify-content-center bg-white bg-opacity-25 rounded-circle text-white"
                style={{ width: "40px", height: "40px" }}
              >
                <FaFacebookF />
              </Link>
              <Link
                to="https://www.linkedin.com/company/elite-body-home-poly-clinic-l-l-c/posts/?feedView=all"
                className="d-flex align-items-center justify-content-center bg-white bg-opacity-25 rounded-circle text-white"
                style={{ width: "40px", height: "40px" }}
              >
                <TiSocialLinkedin />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
